export default class MentionRender {
    constructor (users = []) {
        this.users = users
    }

    replaceMentions (text) {
        const mentions = text.match(/<@\d+?>/gs)

        if (mentions) {
            mentions.forEach((mention) => {
                text = this.replaceSingleMention(text, mention)
            })
        }

        return text
    }

    replaceSingleMention (text, mentionCode) {
        const userId = mentionCode.replace(/^<@(\d+)?>$/, '$1')
        const user = this.users.find(user => user.id === parseInt(userId))

        return text.replace(mentionCode, `<span class="mention" data-index="6" data-denotation-char="@" data-id="${user.id}" data-value="${user.display_name}"><span contenteditable="false"><span>@</span>${user.display_name || 'Unknown'}</span></span>`)
    }
}
